import { render, staticRenderFns } from "./addInspectionPlanList.vue?vue&type=template&id=3120960e&scoped=true"
import script from "./addInspectionPlanList.vue?vue&type=script&lang=js"
export * from "./addInspectionPlanList.vue?vue&type=script&lang=js"
import style0 from "./addInspectionPlanList.vue?vue&type=style&index=0&id=3120960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120960e",
  null
  
)

export default component.exports